import { render, staticRenderFns } from "./mdUserNotification.vue?vue&type=template&id=a2ad8354&scoped=true&"
import script from "./mdUserNotification.vue?vue&type=script&lang=js&"
export * from "./mdUserNotification.vue?vue&type=script&lang=js&"
import style0 from "./mdUserNotification.vue?vue&type=style&index=0&id=a2ad8354&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ad8354",
  null
  
)

export default component.exports